var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.ChooseGoods"),
        width: "960px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { staticStyle: { display: "flex", "margin-bottom": "10px" } },
            [
              _c("span", { staticStyle: { "margin-right": "10px" } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.ContainerSize")) + "：")
              ]),
              _vm._v(
                " " +
                  _vm._s(_vm.containerInfo.eqSize + _vm.containerInfo.eqType) +
                  " "
              ),
              _c(
                "span",
                {
                  staticStyle: { "margin-left": "10px", "margin-right": "10px" }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerNo")) + "：")]
              ),
              _vm._v(" " + _vm._s(_vm.containerInfo.containerNo) + " "),
              _c(
                "span",
                {
                  staticStyle: { "margin-left": "10px", "margin-right": "10px" }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.SealNo")) + "：")]
              ),
              _vm._v(" " + _vm._s(_vm.containerInfo.sealNo) + " ")
            ]
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.goodsMode === _vm.SystemConstants.FCL_TYPE.code ||
                        _vm.goodsMode === _vm.SystemConstants.CONSOLE_TYPE.code,
                      expression:
                        "goodsMode === SystemConstants.FCL_TYPE.code || goodsMode === SystemConstants.CONSOLE_TYPE.code"
                    }
                  ],
                  attrs: { "label-width": "80px", "label-position": "left" }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Supplier") } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.suppliesr,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "suppliesr", $$v)
                                  },
                                  expression: "form.suppliesr"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.OrderNo2") } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.poNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "poNo", $$v)
                                  },
                                  expression: "form.poNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "1" },
                                  on: { click: _vm.searchHandler }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "2" },
                                  on: { click: _vm.chooseHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.confirmImport"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.goodsMode === _vm.SystemConstants.LCL_TYPE.code,
                      expression: "goodsMode === SystemConstants.LCL_TYPE.code"
                    }
                  ],
                  attrs: { "label-width": "80px", "label-position": "left" }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Supplier") } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.suppliesr,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "suppliesr", $$v)
                                  },
                                  expression: "form.suppliesr"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.Anufacturer") }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.anufacturer,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "anufacturer", $$v)
                                  },
                                  expression: "form.anufacturer"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Source") } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.source,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "source", $$v)
                                  },
                                  expression: "form.source"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "1" },
                                  on: { click: _vm.searchHandler }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.OrderNo2") } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.poNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "poNo", $$v)
                                  },
                                  expression: "form.poNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "SKU " + _vm.$t("SeaExport.NO") }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.itemNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "itemNo", $$v)
                                  },
                                  expression: "form.itemNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "HBL" + _vm.$t("SeaExport.NO") }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.hblNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "hblNo", $$v)
                                  },
                                  expression: "form.hblNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "2" },
                                  on: { click: _vm.chooseLclHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.confirmImport"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { "min-height": "350px", padding: "0" }
            },
            [
              _c("cargo-ag-grid", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.goodsMode === _vm.SystemConstants.FCL_TYPE.code,
                    expression: "goodsMode === SystemConstants.FCL_TYPE.code"
                  }
                ],
                staticStyle: { width: "100%", height: "400px" },
                attrs: {
                  "config-module": "130149",
                  "grid-options": _vm.fcl.gridOptions,
                  "column-defs": _vm.fcl.columnDefs,
                  "row-data": _vm.fcl.rowData,
                  "deselect-sub-record": true
                },
                on: { gridReady: _vm.onFclGridReady }
              }),
              _c("cargo-ag-grid", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.goodsMode === _vm.SystemConstants.LCL_TYPE.code,
                    expression: "goodsMode === SystemConstants.LCL_TYPE.code"
                  }
                ],
                staticStyle: { width: "100%", height: "400px" },
                attrs: {
                  "config-module": "130132",
                  "grid-options": _vm.lcl.gridOptions,
                  "column-defs": _vm.lcl.columnDefs,
                  "row-data": _vm.lcl.rowData,
                  "deselect-sub-record": true
                },
                on: { gridReady: _vm.onLclGridReady }
              }),
              _c("cargo-ag-grid", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.goodsMode === _vm.SystemConstants.CONSOLE_TYPE.code,
                    expression:
                      "goodsMode === SystemConstants.CONSOLE_TYPE.code"
                  }
                ],
                staticStyle: { width: "100%", height: "400px" },
                attrs: {
                  "config-module": "130152",
                  "grid-options": _vm.console.gridOptions,
                  "column-defs": _vm.console.columnDefs,
                  "row-data": _vm.console.rowData,
                  "deselect-sub-record": true
                },
                on: { gridReady: _vm.onConsoleGridReady }
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }